<template>
  <div>
    <Header :breadcrumsfirst="breadcrumsfirst" :breadcrumslast="breadcrumslast" />
    <Subheader :title="`${userListId ? 'Edit' : 'Add New'} User List`" />

    <div class="container">
      <div class="row py-3">
        <div class="col-md-3">
          <div class="form-group">
            <label for="userListId" class="custom-label">ID</label>
            <input id="userListId" type="text" class="form-control shadow-none custom-input"
              placeholder="This is autogenerated" readonly v-model="saveData.id">
          </div>
        </div>
        <div class="col-md-9 mb-3">
          <div class="form-group">
            <label for="assetTypeName" class="custom-label">Title</label>
            <input id="assetTypeName" class="form-control shadow-none custom-input" placeholder="Enter text"
              v-model="saveData.name">
          </div>
        </div>
        <div class="col-md-12 mb-3">
          <div class="form-group">
            <label for="assetTypeDesc" class="custom-label">Description</label>
            <input id="assetTypeDesc" class="form-control shadow-none custom-input" placeholder="Enter text"
              v-model="saveData.description">
          </div>
        </div>
        <div class="col-md-12 mb-3">
          <div class="form-group">
            <label for="assetTypeNote" class="custom-label">Notes</label>
            <textarea id="assetTypeNote" class="form-control shadow-none custom-input" rows="4" placeholder="Enter text"
              v-model="saveData.note"></textarea>
          </div>
        </div>
        <div class="col-md-3" v-if="this.userListId">
          <div class="form-group">
            <button type="button" class="btn btn-danger btn-sm delete-button" data-bs-toggle="modal"
              data-bs-target="#exampleModal">Delete</button>
          </div>
        </div>

        <!-- Modal -->
        <deleteModal v-if="this.userListId" :deleteRecord="deleteRecord" />
        <div class="col-md-8 d-flex justify-content-end" v-if="this.userListId">

          <div class="form-group">
            <button type="button" class="btn btn-secondary btn-sm cancel-button" @click="cancelButton()">Cancel</button>
          </div>
        </div>
        <div class="col-md-11 d-flex justify-content-end" v-else>
          <div class="form-group">
            <button type="button" class="btn btn-secondary btn-sm cancel-button" @click="cancelButton()">Cancel</button>
          </div>
        </div>
        <div class="col-md-1 d-flex justify-content-start">
          <div class="form-group">
            <button type="submit" class="btn btn-primary btn-sm submit-button"
              @click="addRoleTypeData()">Submit</button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Subheader from '@/components/Subheader.vue'
import { addAssetType, getByIdAssetType, updateAssetType } from '@/http/iot-asset/asset-type.http'
import deleteModal from '@/components/delete-modal.vue';
export default {
  name: 'asset-type-form',
  components: {
    Header,
    Subheader,
    deleteModal
  },
  data() {
    return {
      // titleConfig:"Add Asset Type",
      userListId: this.$route.params.id,
      saveData: {},
      breadcrumsfirst: "User Management",
      breadcrumslast: "User List",

    }
  },
  mounted() {
    if (this.userListId) {
      getByIdAssetType(this.$route.params.id).then((res) => {
        this.saveData = res
      })
    }
  },
  methods: {
    addRoleTypeData() {
      if (this.userListId) {
        const payload = {
          uuid: this.$route.params.id,
        };
        updateAssetType({ ...payload, ...this.saveData }).then(() => {
          this.saveData.updatedon = new Date().toISOString();
          this.$router.push("/usermanagement/userlist")
        }).catch((error) => {
          this.error = error.message;
        });
      } else {
        addAssetType(this.saveData).then(() => {
          this.$router.push("/usermanagement/userlist")
        }).catch((error) => {
          this.error = error.message;
        });
      }

    },
    cancelButton() {
      this.$router.push("/usermanagement/userlist")
    },
    deleteRecord() {
      this.saveData.issoftdelete = 1;
      const payload = {
        issoftdelete: this.saveData.issoftdelete ? 1 : 0,
        uuid: this.$route.params.id,
      };
      updateAssetType({ ...payload, ...this.saveData }).then(() => {
        this.saveData.updatedon = new Date().toISOString();
        this.$router.push("/usermanagement/userlist")
      })

    },

  }
}
</script>

<style scoped></style>